(function () {
  'use strict';

  if (window.__pojWishlistLoaded) return;
  window.__pojWishlistLoaded = true;

  var handlesKey = 'poj:wishlist:handles';
  var detailsKey = 'poj:wishlist:details';

  function readJson(key, fallback) {
    try {
      var value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeJson(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return;
    }
  }

  function getHandles() {
    var handles = readJson(handlesKey, []);
    return Array.isArray(handles) ? handles.filter(Boolean) : [];
  }

  function setHandles(handles) {
    writeJson(handlesKey, handles.filter(Boolean));
  }

  function getDetails() {
    var details = readJson(detailsKey, {});
    return details && typeof details === 'object' ? details : {};
  }

  function setDetails(details) {
    writeJson(detailsKey, details);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function formatCount(count) {
    return count > 0 ? '(' + count + ')' : '';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    return '£' + (Number(cents || 0) / 100).toFixed(2);
  }

  function updateButtons() {
    var handles = getHandles();
    var count = handles.length;

    document.querySelectorAll('[data-poj-wishlist-count]').forEach(function (node) {
      if (node.hasAttribute('data-poj-wishlist-badge')) {
        node.textContent = count > 0 ? String(count) : '';
        node.hidden = count === 0;
        return;
      }

      node.textContent = node.closest('.poj-wishlist-page__count') ? String(count) : formatCount(count);
    });

    document.querySelectorAll('[data-poj-wishlist-link]').forEach(function (link) {
      link.classList.toggle('has-saved-joys', count > 0);
      link.setAttribute('aria-label', count > 0 ? 'Wishlist, ' + count + ' saved' : 'Wishlist');
    });

    document.querySelectorAll('[data-poj-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var saved = handles.indexOf(handle) !== -1;
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('aria-label', (saved ? 'Remove ' : 'Save ') + (button.getAttribute('data-product-title') || 'product') + (saved ? ' from wishlist' : ' to wishlist'));
    });
  }

  function toggle(button) {
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    var handles = getHandles();
    var details = getDetails();
    var index = handles.indexOf(handle);

    if (index === -1) {
      handles.unshift(handle);
      details[handle] = {
        handle: handle,
        title: button.getAttribute('data-product-title') || '',
        url: button.getAttribute('data-product-url') || '/products/' + handle,
        image: button.getAttribute('data-product-image') || '',
        price: button.getAttribute('data-product-price') || ''
      };
    } else {
      handles.splice(index, 1);
      delete details[handle];
    }

    setHandles(handles);
    setDetails(details);
    updateButtons();
    renderPages();
  }

  function cardMarkup(item) {
    return [
      '<article class="poj-wishlist-card" data-handle="' + escapeHtml(item.handle) + '">',
      '<a class="poj-wishlist-card__image" href="' + escapeHtml(item.url) + '">',
      item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '<span></span>',
      '</a>',
      '<div class="poj-wishlist-card__copy">',
      '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>',
      item.price ? '<span>' + escapeHtml(item.price) + '</span>' : '',
      '<button type="button" data-poj-wishlist-remove="' + escapeHtml(item.handle) + '">Remove</button>',
      '</div>',
      '</article>'
    ].join('');
  }

  function fetchProduct(handle, fallback) {
    return window.fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Not found');
        return response.json();
      })
      .then(function (product) {
        return {
          handle: product.handle || handle,
          title: product.title || fallback.title || handle,
          url: product.url || '/products/' + handle,
          image: product.featured_image || fallback.image || '',
          price: product.price ? formatMoney(product.price) : fallback.price || ''
        };
      })
      .catch(function () {
        return fallback;
      });
  }

  function renderPage(page) {
    var grid = page.querySelector('[data-poj-wishlist-grid]');
    var empty = page.querySelector('[data-poj-wishlist-empty]');
    if (!grid) return;

    var handles = getHandles();
    var details = getDetails();

    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    Promise.all(handles.map(function (handle) {
      return fetchProduct(handle, details[handle] || { handle: handle, url: '/products/' + handle });
    })).then(function (items) {
      grid.innerHTML = items.map(cardMarkup).join('');
    });
  }

  function renderPages() {
    document.querySelectorAll('[data-poj-wishlist-page]').forEach(renderPage);
  }

  function bind() {
    document.addEventListener('click', function (event) {
      var toggleButton = event.target.closest('[data-poj-wishlist-toggle]');
      if (toggleButton) {
        event.preventDefault();
        event.stopPropagation();
        toggle(toggleButton);
        return;
      }

      var removeButton = event.target.closest('[data-poj-wishlist-remove]');
      if (removeButton) {
        event.preventDefault();
        var handle = removeButton.getAttribute('data-poj-wishlist-remove');
        var handles = getHandles().filter(function (item) { return item !== handle; });
        var details = getDetails();
        delete details[handle];
        setHandles(handles);
        setDetails(details);
        updateButtons();
        renderPages();
      }
    });

    updateButtons();
    renderPages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function () {
    updateButtons();
    renderPages();
  });
})();
